import { toast } from 'sonner';

import { api } from '@/contexts/AuthContext';
import { persistCalendarOAuthWizardState } from '@/lib/calendarCampaignFlow';
import { calendarService } from '@/services/calendarService';

/**
 * Campaign wizard OAuth: same browser tab as Google Sheets (no popup).
 * Wizard state is persisted so GoogleCallback returns to /renewal-builder.
 */
export async function startCalendarCampaignOAuth(
  oauthContext: string,
  initialCampaignName?: string
): Promise<boolean> {
  try {
    const res = await api.get(`/google-sheets/auth?context=${encodeURIComponent(oauthContext)}`);
    const url = res.data?.authorization_url;
    if (!url) {
      toast.error('No se pudo obtener la URL de autenticación');
      return false;
    }

    persistCalendarOAuthWizardState(initialCampaignName);
    window.location.href = url;
    return true;
  } catch (e) {
    console.error('calendar auth URL failed', e);
    toast.error('Error al preparar la autenticación con Google');
    return false;
  }
}

/** Disconnect Calendar OAuth, then same-tab re-auth (campaign wizard). */
export async function changeCalendarAccount(
  oauthContext: string = 'calendar-campaign',
  initialCampaignName?: string
): Promise<boolean> {
  try {
    await calendarService.resetCalendarAuth();
  } catch (e) {
    console.error('resetCalendarAuth failed', e);
    toast.error('No se pudo desconectar la cuenta de Google Calendar');
    return false;
  }

  return startCalendarCampaignOAuth(oauthContext, initialCampaignName);
}
